export default "__VITE_ASSET__C71NflPZ__"